import React, {useRef} from "react";
import { GoogleMap, withGoogleMap, Circle } from "react-google-maps";
import {connect} from 'react-redux';

const AddZoneMap = (props) => {
	const circleRef = useRef(null);
	const circleOptions = {strokeColor: "#666"};
	const handleApiLoaded = ( map, maps ) => {
		console.log("oGAL: ", map, maps);
	};

	const onMapClick = event => {
		const latLng = event.latLng;
		props.setCenter([latLng.lat(), latLng.lng()])
	};

	const onCenterChanged = event => {
		const latLng = circleRef.current.getCenter();
		props.setCenter([latLng.lat(), latLng.lng()])
	};

	const onRadiusChanged = event => {
		const radius = circleRef.current.getRadius();
		props.setRadius(radius/1000);
	};

	const circle = props.center && props.radius ? (<Circle
			center={{
				lat: parseFloat(props.center[0]),
				lng: parseFloat(props.center[1])
			}}
			draggable={true}
			editable={true}
			ref={circleRef}
			onCenterChanged={onCenterChanged}
			onRadiusChanged={onRadiusChanged}
			radius={props.radius*1000}
			options={circleOptions}
		/>) : null;

	return (
		<GoogleMap defaultZoom={15}
				   defaultCenter={{ lat: 42.2808, lng: -83.7430 }}
				   onClick={onMapClick}
				   yesIWantToUseGoogleMapApiInternals
				   onGoogleApiLoaded={( map, maps ) => handleApiLoaded(map, maps)}
		>
			{circle}
		</GoogleMap>
	)
};
const mapStateToProps = (state) => {
	return {
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(withGoogleMap(AddZoneMap));
